<template>
  <div class="order-dispatch">
    <PageHeader :breadcrumbs="breadcrumbs" icon="mdi-swap-horizontal" />
    <OrderDispatchStatsCards :stats="dispatchStats" class="mb-4" />
    <OrderDispatchTable
      :dealers="dealers"
      :unassigned-orders="unassignedOrders"
      :rejected-orders="rejectedOrders"
      :assigned-orders="assignedOrders"
      @assign="onAssign"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import OrderDispatchStatsCards from '@/components/OrderDispatchStatsCards';
import OrderDispatchTable from '@/components/OrderDispatchTable';

export default {
  name: 'OrderDispatch',

  components: {
    PageHeader,
    OrderDispatchStatsCards,
    OrderDispatchTable,
  },

  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('dispatch.title'),
          exact: true,
          to: { name: 'OrderDispatch' },
        },
      ];
    },

    dispatchStats() {
      return this.$store.getters['dealerOrders/dispatchStats'];
    },

    dealers() {
      return this.$store.getters['dealerOrders/dealers'];
    },

    unassignedOrders() {
      return this.$store.getters['dealerOrders/unassignedOrders'];
    },

    rejectedOrders() {
      return this.$store.getters['dealerOrders/rejectedOrders'];
    },

    assignedOrders() {
      return this.$store.getters['dealerOrders/assignedOrders'];
    },
  },

  methods: {
    onAssign({ orderId, dealerId }) {
      this.$store.dispatch('dealerOrders/assignOrder', { id: orderId, dealerId });
    },
  },
};
</script>
